import { msalInstance } from './index';
import { apiScopes } from './authConfig';

export async function getAccessToken(): Promise<string | null> {
  const accounts = msalInstance.getAllAccounts();
  if (!accounts.length) return null;
  const result = await msalInstance.acquireTokenSilent({
    scopes: apiScopes,
    account: accounts[0],
  });
  return result.accessToken;
}
